import { render, staticRenderFns } from "./OgHomeScreenshots.vue?vue&type=template&id=8fb8c336&scoped=true"
import script from "./OgHomeScreenshots.vue?vue&type=script&lang=js"
export * from "./OgHomeScreenshots.vue?vue&type=script&lang=js"
import style0 from "./OgHomeScreenshots.vue?vue&type=style&index=0&id=8fb8c336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb8c336",
  null
  
)

export default component.exports